export enum SignUpRoute {
  SignUp = '/signup',
}
